<template>
  <div>
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-alert
      title="Açık İcra Dosyası Yok"
      type="success"
      :closable="false"
      v-if="!Dosyalar && !lo">
    </el-alert>
    <el-table
      class="table-xs"
      style="width: 100%"
      width="100%"
      v-if="Dosyalar"
      :data="Dosyalar"
      show-summary
      :height="Height"
      :summary-method="TableFooter"
      @current-change="KisiSecim">
      <el-table-column
        label="Kişi Bilgi"
        prop="AdSoyad">
      </el-table-column>
      <el-table-column
        width="120"
        align="right"
        label="Dosya Bedeli"
        prop="Tutar">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import Yukleniyor from "../../../../../Doc/Yukleniyor";

export default {
  components: {Yukleniyor},
  props: ["Bina_id"],
  data() {
    return {
      Height: window.innerHeight - 270,
      Dosyalar: null,
      AltToplam: 0,
      lo: true
    }
  },
  methods: {
    KisiSecim(val) {
      this.$router.push('/icra/dosya/' + val.id);
      // console.log(val)
    },
    SayfaYukle() {
      this.$store.dispatch("Get", {path: 'yonetim/bina/ekran/' + this.Bina_id + '/icra'})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Dosyalar = response.Liste
            this.AltToplam = response.AltToplam
            this.lo = false
          } else {
            this.$message.error(response.Mesaj);
            this.hata = response.Hata;
          }
        });
    },
    TableFooter() {
      const sums = [];
      sums[1] = this.AltToplam;

      return sums;
    },
  },
  created() {
    this.SayfaYukle();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Yonetim/bina/Ekran/Detay/BinaIcra.vue